import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper';
import {
  welcomeActivityJsonSchema,
  welcomeActivityUiSchema
} from '@/services/schema/activity';

const WelcomeActivitySetUp = ({formData, handleFormChange}) => {
  const memoizedHandleFormChange = useCallback(
    (data) => handleFormChange(data),
    [handleFormChange]
  );

  return (
    <JsonFormsWrapper
      jsonschema={welcomeActivityJsonSchema}
      uischema={welcomeActivityUiSchema}
      data={formData}
      onChange={memoizedHandleFormChange}
    />
  );
};

WelcomeActivitySetUp.propTypes = {
  formData: PropTypes.object,
  handleFormChange: PropTypes.func.isRequired
};

export default React.memo(WelcomeActivitySetUp);
